import { FrameName } from "../config";
import AbstractRiverTerrainTileEntity from "./AbstractRiverTerrainTileEntity";

class River5TerrainTileEntity extends AbstractRiverTerrainTileEntity {
	public static readonly frameName = FrameName.RIVER5;
}

export default River5TerrainTileEntity;
